import {ContactEquipe, type IContactEquipe} from "./ContactEquipe";
import {AEntity} from "./abstract/AEntity";

export interface IEquipe {
    dirLib: string;
    domLib: string;
    ageLib: string;
    equLib: string;
    equDesc: string;
    equMis: string;
    contacts?: IContactEquipe[];
}

export class Equipe extends AEntity {
    dirLib: string;
    domLib: string;
    ageLib: string;
    equLib: string;
    equDesc: string;
    equMis: string;
    contacts?: ContactEquipe[];

    constructor(equipe: IEquipe) {
        super();
        this.dirLib = equipe.dirLib;
        this.domLib = equipe.domLib;
        this.ageLib = equipe.ageLib;
        this.equLib = equipe.equLib;
        this.equDesc = equipe.equDesc;
        this.equMis = equipe.equMis;
        this.contacts = equipe.contacts && equipe.contacts.map(contact => new ContactEquipe(contact));
    }

    override getId(): string {
        return `${this.dirLib}|${this.domLib}|${this.ageLib}|${this.equLib}`;
    }

    override toJSON(): IEquipe {
        return {
            dirLib: this.dirLib,
            domLib: this.domLib,
            ageLib: this.ageLib,
            equLib: this.equLib,
            equDesc: this.equDesc,
            equMis: this.equMis,
            contacts: this.contacts && this.contacts.map(contact => contact.toJSON())
        }
    }
}
